import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const RowingIcon = observer('RowingIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            width='24'
            height='24'
            viewBox='0 0 50 50'
            fill='#061A32'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            onClick={onClick}
        >
            <circle
                cx='18'
                cy='14'
                r='3'
                fill='fill'
            />
            <path
                d='M15 20 L22 22 L28 20 L30 22 L24 24 L18 23 Z'
                fill='fill'
            />
            <path
                d='M28 20 L42 16 L43 18 L30 23 Z'
                fill='fill'
            />
            <path
                d='M8 30 Q25 35 42 30 L42 32 Q25 37 8 32 Z'
                fill='fill'
            />
        </SvgIcon>
    );
});
